import { render } from "./FixLanguageStringErrorTable.vue?vue&type=template&id=114fc25f&scoped=true"
import script from "./FixLanguageStringErrorTable.vue?vue&type=script&lang=js"
export * from "./FixLanguageStringErrorTable.vue?vue&type=script&lang=js"

import "./edit-translation-table.scss?vue&type=style&index=0&id=114fc25f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114fc25f"]])

export default __exports__